import React, { useState, useEffect, Suspense } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Home from './components/Home';
import DebugMenu from './components/DebugMenu';

// Lazy load components
const AdminDashboard = React.lazy(() => import('./components/AdminDashboard'));
const AdminApproval = React.lazy(() => import('./components/AdminApproval'));
const EditBookingPage = React.lazy(() => import('./components/EditBookingPage'));

function App() {
  const [isDebugMenuVisible, setIsDebugMenuVisible] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.shiftKey && event.key === 'D') {
        setIsDebugMenuVisible((prev) => !prev);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className="app-container">
      <header className="app-header">
        <div className="header-content">
          <Link to="/" className="logo-link">
            <div className="logo-container">
              <div className="logo-title">GBKP Bogor & Bogor Barat</div>
              <div className="logo-subtitle">e-Reservation</div>
            </div>
          </Link>
          <nav className="app-nav">
            <Link to="/admin" className="admin-link">Admin</Link>
          </nav>
        </div>
      </header>
      <main className="main-content">
        <Suspense fallback={<div className="container text-center p-xl">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/approve" element={<AdminApproval />} />
            <Route path="/edit/:bookingId" element={<EditBookingPage />} />
          </Routes>
        </Suspense>
      </main>
      <DebugMenu
        isVisible={isDebugMenuVisible}
        onClose={() => setIsDebugMenuVisible(false)}
      />
    </div>
  );
}

export default App;
